angular.module('salesPath2')
  .controller('apkForbiddenModalCtrl', ['$scope', '$window', 'apkErrorsHelper',
    function($scope, $window, apkErrorsHelper) {

      /**
      * init
      */
      $scope.init = function() {        
        $scope.fireListeners();
      };

      /**
       * Odpalenie watchy
       */
      $scope.fireListeners = function() {
        // continue
        $scope.$on('iHestiaCommonModalOkBtnClicked.apkForbiddenModal', function() {
          $window.open(apkErrorsHelper.portalUrl, '_self');
        });
      };

      $scope.init();

    }
  ]);
